module.exports = __webpack_public_path__ + "static/media/project2.1437304c.jpg";